import {
  mobile,
  backend,
  creator,
  web,
  javascript,
  typescript,
  html,
  css,
  reactjs,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  figma,
  docker,
  meta,
  starbucks,
  tesla,
  shopify,
  carrent,
  jobit,
  tripguide,
  threejs,
  keras,
  kubernetes,
  tensorflow,
  flutter,
  matplotlib,
  python,
  tablue,
  nextjs,
  numpy,
  sklearn,
  hulu,
  htmlBuild,
  news,
  facebook,
  airbnb,
  amazon,
  radiography,
  miingo,
  ace,
  upwork,
  miic,
  hash,
  lawrencegpt,
  pneuomosarscov,
  abdul,
  atwine,
  hall,
  breastCancer,
  lyanda,
  ifl,
  onyxOllama,
  prechohub,
  bodaguy,
  ollama,
  gguf
} from "../assets";

export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "MERN Developer",
    icon: web,
  },
  {
    title: "React Native Developer",
    icon: mobile,
  },
  {
    title: "AI/ML & Data Scientist",
    icon: backend,
  },
  {
    title: "MLops Engineer",
    icon: creator,
  },
];

const technologies = [

  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "Git Hub",
    icon: git,
  },
  {
    name: "Tailwind css",
    icon: tailwind,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "next js ",
    icon: nextjs,
  },
  {
    name: "TypeScript",
    icon: typescript,
  },
  {
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    name: "Node JS",
    icon: nodejs,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },
  {
    name: "docker",
    icon: docker,
  },
  {
    name: "kubernetes",
    icon: kubernetes,
  },
  {
    name: "flutter",
    icon: flutter,
  },
  {
    name: "python",
    icon: python,
  },
  {
    name: "numpy",
    icon: numpy,
  },
  {
    name: "ollama",
    icon: ollama,
  },
  {
    name: "matplotlib",
    icon: matplotlib,
  },
  {
    name: "sklearn",
    icon: sklearn,
  },
  {
    name: "tableau",
    icon: tablue,
  },

  {
    name: "tensorflow",
    icon: tensorflow,
  },
  {
    name: "keras",
    icon: keras,
  },
  {
    name: "gguf",
    icon: gguf,
  },
];

const experiences = [
  {
    title: "React.js Developer",
    company_name: "Miingo",
    icon: starbucks,
    iconBg: "#383E56",
    date: "Nov 2022 - March 2023",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Web Developer",
    company_name: "Makerere Innovation and Incubation Center (MIIC HUB), Kampala, Uganda",
    icon: miic,
    iconBg: "#383E56",
    date: "Jan 2022 - Feb 2023",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Contributing to various startup projects and personally worked on the rental app called Senguka and majorly contributed the frontend of the application",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Data scientist",
    company_name: "African Centers of Excellence for Bioinformatics (IDI)",
    icon: ace,
    iconBg: "#E6DEDD",
    date: "January 2024 - Present",
    points: [
      "Deploying Machine Learning models in production and at scale.",
      "Configuring secure endpoints to machine learning projects using kubernetes.",
      "Collaborating with cross-functional teams including Data Engineers, Bioinformaticians,Virtual Reality Engineers and other developers to create high-quality health care products.",
      "Implementing front end  design and coming up with mvps for developed machine learning models.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Chief Technology Officer",
    company_name: "Lyanda Technologies",
    icon: lyanda,
    iconBg: "#E6DEDD",
    date: "May 2024 - Present",
    points: [
      "Overseeing the technical strategy and development of innovative electric vehicle solutions, including battery systems and charging infrastructure.",
      "Collaborating with cross-functional teams including Electrical Engineers, Mechanical Engineers, Software Developers, and Product Managers to create high-performance EV technologies.",
      "Ensuring the integration of cutting-edge software, AI, and machine learning into vehicle systems to enhance performance and energy efficiency.",
      "Managing product development cycles, from concept and MVP to final production and deployment.",
      "Leading the development of IoT-enabled smart vehicle features, such as real-time monitoring, diagnostics, and autonomous driving functionalities.",
      "Participating in code and design reviews, providing guidance on scalability, security, and energy efficiency."
    ],
  },
];

const testimonials = [
  {
    testimonial:
      "Lawrence helped us grow in the line of deploying health data science projects at scale..",
    name: "Mugume atwine",
    designation: "Data scientist",
    company: "ACE",
    image: atwine,
  },
  {
    testimonial:
      "I've never met an Engineer who truly cares about their clients' success like Lawrence does.",
    name: "Chambaga Abdul",
    designation: "Software Developer",
    company: "UIBFS",
    image: abdul,
  },
  {
    testimonial:
      "i have worked with lawrence on a couple of projects and he really proved to be a good Engineer.",
    name: "Enoch hall Asanda",
    designation: "Software Engineer",
    company: "kuduAfrica",
    image: hall,
  },
];

const projects = [
  {
    name: "Onyx-Ollama Bridge",
    description:
      "Open-source LLM integration system enabling locally hosted Large Language Models with Onyx backend infrastructure for privacy-preserving, healthcare-oriented AI workflows. Enhanced performance for resource-constrained environments.",
    tags: [
      {
        name: "Python",
        color: "blue-text-gradient",
      },
      {
        name: "Ollama & Onyx",
        color: "green-text-gradient",
      },
      {
        name: "Docker & BentoML",
        color: "pink-text-gradient",
      },
    ],
    image: onyxOllama, 
    source_code_link: "#",
  },
  {
    name: "Heal AI Chatbot",
    description:
      "Retrieval-Augmented Generation (RAG)-based chatbot enhancing pandemic preparedness in Uganda's health sector. Deployed production MLOps pipeline with Kubernetes orchestration.",
    tags: [
      {
        name: "Hugging Face",
        color: "blue-text-gradient",
      },
      {
        name: "Kubernetes & BentoML",
        color: "green-text-gradient",
      },
      {
        name: "Node.js & MongoDB",
        color: "pink-text-gradient",
      },
    ],
    image: onyxOllama, 
    source_code_link: "#",
  },

  {
    name: "Radiography Platform",
    description:
      "Full-stack web platform providing accessible sonography and radiography education at low cost. Integrates charity initiatives and environmental advocacy to promote sustainable healthcare education in underserved communities.",
    tags: [
      {
        name: "React",
        color: "blue-text-gradient",
      },
      {
        name: "MongoDB",
        color: "green-text-gradient",
      },
      {
        name: "Tailwind CSS",
        color: "pink-text-gradient",
      },
    ],
    image: ifl,
    source_code_link: "https://www.infinite-foundation.com",
  },

  {
    name: "BodaGuy Logistics",
    description:
      "Smart eco-friendly logistics platform providing real-time GPS tracking and route optimization for electric motorcycle deliveries. WebSocket-based live updates with Mapbox API integration.",
    tags: [
      {
        name: "React Native",
        color: "blue-text-gradient",
      },
      {
        name: "Node.js & MongoDB",
        color: "green-text-gradient",
      },
      {
        name: "WebSockets & Mapbox",
        color: "pink-text-gradient",
      },
    ],
    image: bodaguy, 
    source_code_link: "https://play.google.com/store/apps/details?id=com.bodaguy",
  },

  {
    name: "Miscarriage Risk Prediction",
    description:
      "Machine learning system predicting miscarriage likelihood for expectant mothers using clinical data. Deployed in healthcare settings for clinical decision support and early intervention.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: hash,
    source_code_link: "#",
  },
  {
    name: "Breast Cancer Detection",
    description:
      "Machine learning system for mammogram image classification to detect early-stage breast cancer. Mobile application deployment supporting radiologists in diagnostic accuracy and speed.",
    tags: [
      {
        name: "TensorFlow & Keras",
        color: "blue-text-gradient",
      },
      {
        name: "Flutter",
        color: "green-text-gradient",
      },
      {
        name: "Scikit-learn",
        color: "pink-text-gradient",
      },
    ],
    image: breastCancer,
    source_code_link: "https://www.asbcb.org/event/codeathon/asbcb-omics-codeathon-october-2023",
  },
  {
    name: "PneumoSarsCov2 Detection",
    description:
      "AI system for screening chest X-ray images to detect pneumonia and COVID-19. Mobile deployment for point-of-care diagnostics supporting pandemic response and rapid screening.",
    tags: [
      {
        name: "TensorFlow & Keras",
        color: "blue-text-gradient",
      },
      {
        name: "Flutter",
        color: "green-text-gradient",
      },
      {
        name: "Scikit-learn",
        color: "pink-text-gradient",
      },
    ],
    image: pneuomosarscov,
    source_code_link: "https://www.asbcb.org/event/codeathon/asbcb-omics-codeathon-april-2023",
  },

  {
    name: "Precho Hub",
    description:
      "Online education platform designed as the future of learning for African students. Provides accessible, curriculum-aligned digital learning resources and interactive educational content.",
    tags: [
      {
        name: "React",
        color: "blue-text-gradient",
      },
      {
        name: "Node.js",
        color: "green-text-gradient",
      },
      {
        name: "MongoDB",
        color: "pink-text-gradient",
      },
    ],
    image: prechohub,
    source_code_link: "https://www.prechohub.org",
  },

];

export { services, technologies, experiences, testimonials, projects };
